import React, {useState, useEffect} from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import * as Yup from "yup";
import {useFormik} from "formik";

const ShareModal = ({isOpen, toggle, allUsers, rcaName}) => {
  const [ assignedUser, setAssignedUser ] = useState(null);
  const [ searchQueryUser, setSearchQueryUser ] = useState("");
  const [ sharedWith, setSharedWith ] = useState([]);
  const [selectedOption, setSelectedOption] = useState('view-edit-share');
  
  const filteredUsers = Object.entries(allUsers).filter(([id, user]) => {
    return (
      user.name.toLowerCase().includes(searchQueryUser.toLowerCase())
    );
  });

  const validateFunction = async (values) => {
    let errors = {}
    
    if (!values.title || values.title.trim().length === 0) {
      errors['title'] = 'Please Enter the Title';
    }
  
    if (!values.description || values.description.trim().length === 0) {
      errors['description'] = 'Please enter the description';
    }

    if(!values.label){
      errors['label'] = "Please select a label";
    }

    return errors;
  }

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    validate: validateFunction,

    initialValues: {
      share_to: assignedUser ? (allUsers[assignedUser]?.name || '') : '',
    },

    validationSchema: Yup.object({
      title: Yup.string().required("Please Enter title"),
      due_date: Yup.string().required("Please Enter due date"),
      description: Yup.string().required("Please Enter description"),
    }),
    onSubmit: (values) => {
      if (selectedLabel && assignedUser){
        submit();
        toggle(); 
        validation.resetForm()
        setSelectedLabel(null);
      }
    }
  });

  const selectUser = (user) => {
    setSharedWith(prevUsers => [...prevUsers, user]);
    setSearchQueryUser(""); 
    setAssignedUser(null);
  };

  return(
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalBody>
        <div style={{width:"100%", display:"flex", justifyContent:"space-between"}}>
          <div><h5>{rcaName}</h5></div>
          <span role="button" onClick={toggle}>
            <i className="bx bx-x text-white font-size-20"></i>
          </span>
        </div>
        <hr></hr>
        <div className="w-100">
          <div className="w-100">
            <input
              id="share_to"
              name="share_to"
              value={assignedUser ? assignedUser.name : searchQueryUser}
              onChange={(e) => {setSearchQueryUser(e.target.value)
                validation.setFieldValue("share_to", assignedUser ? assignedUser.name : "");
              }}
              className="input w-100"
              placeholder="Search: User"
            ></input>
            {searchQueryUser && filteredUsers.length > 0 && (
              <div className="rca-search">
                <ul>
                  {filteredUsers.map(([id, user]) => (
                    <li onClick={() => selectUser(user)} key={id}>
                      <div className="d-flex justify-content-between align-items-center p-2">
                        {user.name}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
                )}
                {validation.errors.share_to &&
                validation.touched.share_to && (
                  <div className="text-danger">
                    {validation.errors.share_to}
                  </div>
                )}
          </div>
        </div>
        <div className="my-4">
          <h6>Shared with</h6>
        </div>
        <div className="pb-2">
          {sharedWith.map((user) => (
            <div key={user.id} className="d-flex justify-content-between">
              <div>
                {user.name}
              </div>
              <div>
              <select 
                className="custom_select" 
                value={selectedOption} 
                onChange={(e) => setSelectedOption(e.target.value)}
              >
                <option value="view">Can View</option>
                <option value="view-edit">Can View and Edit</option>
                <option value="view-edit-share">Can View, Edit, and Share</option>
              </select>
              </div>
             </div>
          ))}
        </div>
        <div className="w-100 d-flex justify-content-end mt-2">
          <button className="btn btn-primary">Done</button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ShareModal;